export var DEFAULT_FILTER_GROUP = 'DEFAULT_FILTER_GROUP';
export var DEFAULT_FILTER_GROUP_NAME = 'Default Filter';
export var SEARCH_ONLY_FILTER_GROUP = 'SEARCH_ONLY_FILTER_GROUP';